<template>
  <!-- prettier-ignore -->
  <index-content>
    <template #options>
      <nb-download :url="CONFIG_CSV_URL" :params="condition" />
      <nb-add @on-click="openModal" />
    </template>
    <search-condition searchable :loading="searching" @do-search="search">
      <ns-company v-model="condition.companyId" />
      <n-field-id v-model="condition.customerId" label="customerId" />
      <n-field-id v-model="condition.accountId" label="accountId" />
      <n-field-enum v-model="condition.configType" enum-name="CustomerConfigType" label="configType" all-option />
    </search-condition>
    <n-table :total="total" :page-no="pageNo" :page-size="pageSize" :searched="searched" :searching="searching" :has-result="hasResult" @on-page-no="onPageNo" @on-page-size="onPageSize">
      <table class="table table-bordered table-hover table-striped text-center n-table">
        <thead>
          <tr>
            <th class="col-weight-10">{{ $t('label.company') }}</th>
            <th class="col-weight-10">{{ $t('label.customerId') }}</th>
            <th class="col-weight-10">{{ $t('label.accountId') }}</th>
            <th class="col-weight-10">{{ $t('label.status') }}</th>
            <th class="col-weight-10">{{ $t('label.configType') }}</th>
            <th class="col-weight-47">{{ $t('label.configValue') }}</th>
            <th class="n-table-timestamp">{{ $t('label.lastUpdate') }}</th>
            <th v-table-action class="action-edit">{{ $t('label.action') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in records" :key="row.id">
            <td v-selection:[`company.company`]="row.companyId"></td>
            <td class="n-ellipsis">
              <n-modal-link name="customer.profile" :value="row.customerId" />
            </td>
            <td class="n-ellipsis">
              <n-modal-link name="customer.account" :value="row.accountId" />
            </td>
            <td v-enums:CustomerConfigStatus="row.status"></td>
            <td v-enums:CustomerConfigType="row.configType"></td>
            <td class="n-ellipsis" :title="row.configValue">{{ row.configValue | hyphen }}</td>
            <td>{{ row.updateDatetime | datetime }}</td>
            <td class="n-button-box">
              <nb-custom v-if="hasRW && row.editable" class="btn-fixed-width" type="error" custom-icon="fa fa-edit" text="edit" @on-click="openModal(row)" />
              <nb-custom v-else type="info" class="btn-fixed-width" text="detail" @on-click="openDetail(row)" />
            </td>
          </tr>
        </tbody>
      </table>
    </n-table>
  </index-content>
</template>

<script>
import CustomerView from './view';
import ModalConfig from './ModalConfig';
import { Parser } from '@/helpers/operators';
import PaginateMixin from '@/mixins/paginate-mixin';
import { CONFIG_CSV_URL, fetch } from '@/api/customer/customer-config';

export default CustomerView.extend({
  name: 'CustomerConfig',
  mixins: [PaginateMixin],
  data() {
    return {
      condition: {
        configType: 0,
        companyId: null,
        accountId: null,
        customerId: null,
      },
      CONFIG_CSV_URL,
    };
  },
  methods: {
    doSearch(params) {
      let p = { ...params, ...this.condition };
      return fetch(p);
    },

    openModal(model = {}) {
      this.createModal(ModalConfig, { model, on: this });
    },

    openDetail(model = {}) {
      this.createModal(ModalConfig, { model, props: { detail: true }, on: this });
    },

    parse(rows) {
      const { ACTIVE } = this.$enums.CustomerConfigStatus;
      const setEditable = o => (o.editable = [ACTIVE].includes(o.status));
      this.records = Parser(rows.records, [setEditable]);
    },
  },
});
</script>

<style lang="scss" scoped>
@import '~@/style/table';

.n-table {
  th.rw-action,
  th.ro-action {
    width: $action-detail;
  }

  &.active th.rw-action {
    width: 9rem;
  }

  .btn-fixed-width {
    width: 58px;
    min-width: 58px;
    max-width: 58px;
  }
}
</style>
